import React from 'react';
import PropTypes from 'prop-types';
import routes from '../../routes';

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';
class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.validateParam('failureRedirect');
    this.validateParam('redirect_uri');
  }

  validateParam = (param) => {
    const params = new URLSearchParams(window.location.search);
    const queryParm = params.get(param);
    if (
      queryParm &&
      !queryParm.match(
        /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi
      )
    ) {
      console.warn(`BLOCKED INSECURE QUERY PARAM - ${param}`);
      params.set(param, '#');
      window.history.replaceState(null, '', `?${params}${window.location.hash}`);
      window.location.reload()
    }
  };

  render() {
    return (
      <div className='app'>
        <main>{routes}</main>
      </div>
    );
  }
}
App.propTypes = {
  routes: PropTypes.object.isRequired,
};

export default App;
